import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CaseReportComponent} from './case-report.component';


const routes: Routes = [
  {
    path: 'casereport/:source/:visit_id', component: CaseReportComponent
  }
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/case-report/case-report.routing.ts